import { render, staticRenderFns } from "./InactiveUserCard.vue?vue&type=template&id=a8956330&"
import script from "./InactiveUserCard.vue?vue&type=script&lang=js&"
export * from "./InactiveUserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports